/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FileUploader} from 'ng2-file-upload';
import {translations} from '../../../../environments/translations.ru';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadComponent extends BaseFieldType implements OnInit {
  file: File = null;
  uploader: FileUploader;
  hasDropZoneOver = false;

  get fileType() {
    return this.file?.type;
  }

  get fileName() {
    return this.file?.name ? this.file.name : (this.field.props.fileOptions?.name || translations.chooseFile2);
  }

  get fileSize(): string {
    return this.file ? this.format(this.file.size) : '';
  }

  get maxFileSize(): string {
    const maxFileSize = this.field.props.fileOptions.maxFileSize;

    return maxFileSize ? this.format(maxFileSize) : '';
  }

  get allowedMimeTypes() {
    return this.field.props?.fileOptions?.allowedMimeType ? this.field.props.fileOptions.allowedMimeType : null;
  }

  ngOnInit() {
    this.uploader = new FileUploader({url: null});
  }

  upload(): void {
    if (this.uploader.queue.length) {
      this.hasDropZoneOver = false;

      this.file = this.uploader.queue[0]._file;
      this.formControl.patchValue(this.file);

      if (this.file.size > this.field.props.fileOptions.maxFileSize) {
        this.formControl.setErrors({maxFileSizeExceed: {value: this.formControl.value.size}});
      }
      if (this.field.props.fileOptions.allowedMimeType &&
        !this.field.props.fileOptions.allowedMimeType.includes(this.file.type)) {
        this.formControl.setErrors({mimeTypeNotAllowed: {value: this.formControl.value.type}});
      }
    }

    if (!this.formControl.valid) {
      this.file = null;
      this.uploader.clearQueue();
    }
  }

  format(val: number) {
    return Math.floor(val / 1024 / 1024) + 'Mb';
  }

  fileOver(value: boolean): void {
    this.hasDropZoneOver = value;
  }

}
